import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PrimaryButton } from "../components/Common/PrimaryButton";
import { SecondaryButton } from "../components/Common/SecondaryButton";
import CheckIcon from "../assets/icons/accept.png";

const results = {
  quiz1: [
    {
      "grade": "A",
      "title": "You’re Ready to Make the Leap!",
      "caption": "You’re showing all the signs of someone meant for coaching! 🌟\nYou’re craving change, thrive when helping others, and want a career that’s more meaningful and flexible. ICF certification could be your gateway to a deeply rewarding path.\n👉 What You’ll Gain:\n- A global, respected coaching credential 🌍\n- Freedom to work on your terms 💼\n- The chance to create real change in people’s lives 💖\nYou're a natural fit — now it's time to go pro!",
      "link": ""
    },
    {
      "grade": "B",
      "title": "You're Almost There – Let's Close the Gap",
      "caption": "You’re leaning into the idea of coaching, and that’s a great start. 💪\nWhile you're not fully clear on the path yet, your desire to help others and frustration with your current job are signs coaching could be for you.\n👉 ICF Certification Can Help You:\n- Turn your supportive nature into a real skillset 🎓\n- Transition smoothly into a more purposeful career 🌱\n- Build confidence to coach with clarity and impact 🔍\nLet’s build the bridge from passion to profession.",
      "link": ""
    },
    {
      "grade": "C",
      "title": "You’ve Got Coaching Curiosity",
      "caption": "You're intrigued by the idea of coaching, even if you’re unsure how it fits. 🤔\nYou’ve thought about growth, change, and flexibility — and coaching could be your vehicle to get there. \n👉 What Coaching Can Offer:\n- Skills that apply to any leadership or personal role 📈\n- A way to test the waters without full commitment 🌊\n- Clarity around your future direction 🌟\nYou’re at a great place to explore your next step.",
      "link": ""
    },
    {
      "grade": "D",
      "title": "You Like the Idea — But You Need a Bit More Clarity",
      "caption": "You're open to growth and change, but coaching might still be a bit of a question mark. 🤷‍♀️\nIf you're burnt out, seeking flexibility, or just feel like something’s missing, coaching might offer a surprising new path.\n👉 Why You Might Want to Explore Coaching:\n- It aligns with values like freedom and impact ✨\n- It can evolve alongside your current career 🛠️\n- It starts with YOU — no need to leap without looking 👀\nLet’s explore this idea at your pace.",
      "link": ""
    },
    {
      "grade": "E",
      "title": "You’re Sitting on Potential",
      "caption": "You may not see yourself as a coach right now — but your answers suggest there’s real potential. 🌱\nMaybe you haven’t realized how your skills, experiences, or desire for more flexibility could point toward coaching.\n👉 Consider This:\n- Coaching can start as a side path, not a full leap 🚶‍♂️\n- Your advice-giving nature could become a superpower 💬\n- There's zero pressure — just possibility 💡\nYou’re closer than you think.",
      "link": ""
    },
    {
      "grade": "F",
      "title": "You Might Benefit From Coaching Skills — Even if Not as a Career",
      "caption": "It sounds like coaching as a profession isn’t your goal — and that’s okay. 😌\nBut learning foundational coaching skills could still benefit your communication, leadership, and overall satisfaction.\n👉 What You Might Get Out of Coaching Training:\n- Better listening and people skills 👂\n- Stronger team collaboration and support 🤝\n- Clarity on whether coaching could ever be your thing 🧐\nYou don’t have to be a coach to think like one.",
      "link": ""
    },
    {
      "grade": "G",
      "title": "You’re Not Looking for Change — But Keep an Open Mind",
      "caption": "You’re likely pretty comfortable in your current situation. 👌\nAnd that’s great! Still, many future coaches started exactly where you are — and discovered something life-changing.\n👉 Why Coaching Might Still Surprise You:\n- It's a powerful personal development tool 🔧\n- It enhances leadership without changing careers 🎯\n- It may open doors you didn’t know existed 🚪\nNo pressure, just possibilities.",
      "link": ""
    },
    {
      "grade": "H",
      "title": "You’re Skeptical — And That’s Totally Valid",
      "caption": "You may have doubts about coaching — whether it’s hype, or just not your thing. 😏\nTotally understandable. But the coaching profession is evolving fast and is now a critical skill across industries.\n👉 Why It’s Worth a Second Look:\n- Coaching isn't therapy or consulting — it's unique 🔍\n- It's a powerful leadership and career accelerator 🚀\n- You don’t need to commit — just learn more 🔓\nCuriosity might be all it takes to get started.",
      "link": ""
    },
    {
      "grade": "I",
      "title": "Coaching Isn’t for You Right Now — And That’s Fine!",
      "caption": "Coaching may not be on your radar or part of your goals — and that’s completely okay. 🙌\nEveryone’s journey is different. If you ever reconsider, coaching will still be here for you.\n👉 If You Revisit It Someday:\n- There are flexible, low-commitment ways to explore it 🧭\n- Coaching can complement your future growth 📚\n- You’ll always be welcome to learn more 💬\nSometimes, a 'no' now opens up to a 'maybe later.'",
      "link": ""
    }
  ],
  quiz2: [
    {
      "grade": "A",
      "title": "You’re the Ideal Flexible Coach-in-the-Making!",
      "caption": "You have the perfect balance of time, motivation, and passion to thrive as a coach. With your flexibility and strong desire to make a difference, coaching can offer you meaningful work without sacrificing your lifestyle.\n\n👉 Why Coaching Suits You:\n- You already prioritize work-life harmony 🌸\n- You enjoy helping others in manageable ways 🙌\n- You have the drive to build something fulfilling at your own pace\n\nNow’s the time to take that first step—coaching could be the flexible, fulfilling future you’ve been waiting for.",
      "link": ""
    },
    {
      "grade": "B",
      "title": "You’re Close to Finding Your Flexible Calling",
      "caption": "You’re motivated and value meaningful, low-pressure work. Coaching could be a perfect outlet for that! With a little structure and the right tools, you can help others while keeping your freedom.\n\n✅ You’d enjoy:\n- Low-commitment training options\n- Remote or part-time coaching gigs\n- A career that scales with your lifestyle\n\nIt’s worth exploring flexible paths to see how coaching fits into your unique rhythm.",
      "link": ""
    },
    {
      "grade": "C",
      "title": "You’re Open to Possibility—And That’s a Great Start",
      "caption": "You want something meaningful but not too overwhelming, and that’s totally valid. Coaching may be a great option if you want a career you can ease into, with low stress and high impact.\n\n✨ Consider:\n- Intro coaching certifications that don’t require full-time commitment\n- Projects where you help others in small but impactful ways\n\nYou’re right at the beginning of something exciting—no need to rush.",
      "link": ""
    },
    {
      "grade": "D",
      "title": "You’re Looking for Calm, Not Chaos",
      "caption": "Right now, you prioritize peace and flexibility—and that’s completely okay. A full-on coaching career may not be your goal yet, but there are ways to gently explore helping others that fit your calm lifestyle.\n\n🧘‍♀️ Think:\n- Light, part-time opportunities with minimal stress\n- Mentoring or coaching small groups occasionally\n- Dipping your toes in before diving deep\n\nYou don’t need to commit big—start small and stay stress-free.",
      "link": ""
    },
    {
      "grade": "E",
      "title": "You Crave Freedom First",
      "caption": "You’re not ready for a traditional job or anything too structured—and that’s totally valid. You want ultimate control over your time, energy, and mental space.\n\nCoaching could still work in micro-ways:\n- Occasional online sessions\n- Coaching circles or peer-led groups\n- Non-traditional paths like journaling or self-coaching\n\nStay in your flow and explore only what aligns with your current peace.",
      "link": ""
    },
    {
      "grade": "F",
      "title": "You Prefer Minimal Commitment",
      "caption": "Right now, anything that feels like 'work' might not be ideal for you—and that’s perfectly fine. You want income with ease, flexibility with freedom, and coaching might only appeal if it's on your exact terms.\n\n🚶‍♀️ Explore options like:\n- One-off workshops or community-based roles\n- Sharing wisdom in informal settings\n\nNo pressure—just possibilities.",
      "link": ""
    },
    {
      "grade": "G",
      "title": "You’re Content with the Quiet Life",
      "caption": "You're happy to avoid responsibility-heavy roles, and prefer simplicity. Coaching may feel like a stretch now, but it could still play a light-touch role in your life if you ever seek deeper meaning or connection.\n\nIf you're curious, try:\n- Joining a casual learning circle\n- Being a listener or supporter in a community group\n\nLow-key ways to make an impact—only if and when you're ready.",
      "link": ""
    },
    {
      "grade": "H",
      "title": "You Might Not Be Looking for a Career Shift",
      "caption": "Coaching probably isn't on your radar right now—and that’s okay. You’re focused on simplicity and peace, and there’s no need to push beyond what feels right for you.\n\nStay where you're comfortable, and only explore new roles if it feels exciting—not stressful.",
      "link": ""
    },
    {
      "grade": "I",
      "title": "You’re in Full Relax Mode",
      "caption": "A career shift? Probably not right now. You're in a season of rest, and structured or even part-time commitments may feel too much. You deserve this space.\n\n🛋 When you're ready, there are stress-free ways to ease into new roles—but for now, just be.",
      "link": ""
    }
  ],
  quiz3: [
    {
      "grade": "A",
      "title": "You’re Ready for a Bold Career Leap!",
      "caption": "Your answers show that you’re clear on your purpose and fully prepared to make a significant career transformation. You’re excited about guiding others, and you see coaching as the opportunity to create a deep impact while honoring your personal values. Now is your time to take the plunge and make a powerful change!",
      "link": ""
    },
    {
      "grade": "B",
      "title": "You’re Primed for a Meaningful Change",
      "caption": "You have a strong drive to reimagine your career and embrace new challenges. Balancing family and work is important to you, yet you’re ready to expand your influence through coaching. With a little extra support and planning, you can confidently transition into a role that honors both your personal and professional ambitions.",
      "link": ""
    },
    {
      "grade": "C",
      "title": "You’re on the Cusp of Transformation",
      "caption": "Your responses indicate that you’re nearly ready to shift to a more fulfilling career. You understand your priorities and see the potential in coaching as a way to balance personal values with professional growth. A few more steps in preparation could empower you to make that exciting transition.",
      "link": ""
    },
    {
      "grade": "D",
      "title": "You’re Exploring New Horizons",
      "caption": "You’re interested in finding a new career path that supports your lifestyle, yet you may still be weighing the challenges of change. Coaching feels like a promising way to achieve the balance and fulfillment you’re seeking. With some guidance and gradual steps, you can transform your passion into a rewarding profession.",
      "link": ""
    },
    {
      "grade": "E",
      "title": "Your Potential Is Recognized",
      "caption": "You’re curious about exploring different opportunities, and you see the appeal of a career that aligns with both family life and personal growth. While you aren’t ready for a dramatic change, you can begin exploring coaching in small, manageable ways that respect your schedule and responsibilities.",
      "link": ""
    },
    {
      "grade": "F",
      "title": "You’re Reflecting on Stability",
      "caption": "Your current focus leans toward maintaining stability and comfort. Although you’re interested in the idea of using your skills to help others, you prefer to take a subtle approach to change—one that respects your need for balance and minimizes disruption to your established routine.",
      "link": ""
    },
    {
      "grade": "G",
      "title": "You Prioritize Family and Home",
      "caption": "It’s clear that your main focus is on your family and creating a balanced home life. While the concept of a coaching career appeals to you in theory, you’re not looking to disrupt the comfortable rhythm of your day-to-day life. Your strengths shine in maintaining a nurturing and stable environment.",
      "link": ""
    },
    {
      "grade": "H",
      "title": "Your Attention Is on Personal Well-Being",
      "caption": "You are cautious about stirring major change. Your responses suggest that you value a secure work-life balance and prefer keeping your daily routine stress-free. Although coaching might offer a fulfilling path in the future, right now your focus is on sustaining personal well-being and stability.",
      "link": ""
    },
    {
      "grade": "I",
      "title": "For Now, It’s All About Home & Family",
      "caption": "Your current priorities are fully centered on home and family. A major career shift or a foray into coaching isn’t on your radar at the moment—and that’s perfectly okay. Your commitment to personal and family well-being is a success in itself, and new professional opportunities can await when and if your priorities change.",
      "link": ""
    }
  ],
  quiz4: [
    {
      "grade": "A",
      "title": "You’re Ready to Make the Leap!",
      "caption": "You’re showing all the signs of someone who is ready for change! 🌟\nYou’re craving more flexibility, balance, and purpose in your life. Coaching could be your perfect path to gain the freedom to support your family while making a real impact.\n👉 What You’ll Gain:\n- A fulfilling career that fits your family needs 👨‍👩‍👧‍👦\n- The opportunity to coach others while working from home 🏡\n- The flexibility to control your schedule 💼\nYou're primed for success — time to take action and become a certified coach!",
      "link": ""
    },
    {
      "grade": "B",
      "title": "You're Almost There – Let’s Close the Gap",
      "caption": "You’re getting closer to the path of coaching, but a few things still need alignment. 💪\nYou’re craving flexibility and purpose, but may need more time and confidence to take the leap.\n👉 ICF Certification Can Help You:\n- Learn the skills to transition into coaching 🎓\n- Work around your family’s needs while growing your career 🌱\n- Build confidence in helping others with real tools 🔧\nLet’s bridge the gap between where you are and where you want to be.",
      "link": ""
    },
    {
      "grade": "C",
      "title": "Flexibility and Fulfillment Are Within Reach",
      "caption": "You’re eager for a career that allows you to help others while offering flexibility for your family life. 🤗\nCoaching could be the perfect fit for your skillset, but you’ll need to gain the confidence to dive into it full-time.\n👉 What You’ll Gain:\n- An opportunity to build a fulfilling career on your terms 🧑‍💼\n- Skills to balance work, life, and passion 🔄\n- A new way of making an impact with your family in mind 💖\nIt's time to start preparing yourself for a career that fits your needs.",
      "link": ""
    },
    {
      "grade": "D",
      "title": "Ready for a Career Shift?",
      "caption": "You’re passionate about making a difference and are ready for something more fulfilling! 🌱\nYour desire for a meaningful career aligns with coaching, but you might need to work on the transition and confidence-building.\n👉 Coaching Can Provide You With:\n- A new career that brings you purpose and impact 🌟\n- The flexibility to be there for your family while helping others 💪\n- Tools and resources to guide your shift smoothly 🔑\nGet ready to take the next step toward a fulfilling coaching career.",
      "link": ""
    },
    {
      "grade": "E",
      "title": "You’re Getting There – Let’s Explore Your Options",
      "caption": "You're on the right track, but there may still be some uncertainty in balancing work, family, and career shifts. 🚀\nCoaching could be the perfect solution, but it will require more self-confidence and planning.\n👉 What You’ll Gain:\n- Clarity in your next career step 🔍\n- Flexibility to work with clients and care for your family 💖\n- A way to help others without sacrificing your own goals 🙌\nLet's continue to explore how coaching can align with your needs.",
      "link": ""
    },
    {
      "grade": "F",
      "title": "Let's Take It One Step at a Time",
      "caption": "You're not quite there yet, but you’re moving in the right direction! ✨\nYou’re still figuring out your balance between career, family, and personal growth, and coaching could be the right answer once you're ready.\n👉 How Coaching Can Help:\n- It offers a path to personal fulfillment 🌸\n- You’ll learn valuable skills to balance life and work 💡\n- Coaching will give you the tools to thrive with a flexible career 🏆\nContinue exploring how coaching can fit into your life at the right time.",
      "link": ""
    },
    {
      "grade": "G",
      "title": "The Path to Coaching Is Worth Exploring",
      "caption": "You’re unsure about making a change, but coaching could still be a great fit for you! 💭\nIf flexibility and a new career are on your mind, coaching can help you create a path to both. It may take time and effort to build confidence, but it’s worth the journey.\n👉 What You’ll Gain:\n- A career that’s flexible and fulfilling 🌱\n- Tools to help others, while still managing your own responsibilities 👨‍👩‍👧‍👦\nConsider how coaching might fit into your life as you take the next step.",
      "link": ""
    },
    {
      "grade": "H",
      "title": "Finding Clarity Will Help You Move Forward",
      "caption": "You’re facing some hurdles in balancing career, family, and self-growth, but you’re closer than you think! 🔍\nCoaching could be the ideal career shift for you once you gain clarity and start setting boundaries for your time.\n👉 How Coaching Can Help:\n- Provides clarity in your career goals 🎯\n- Offers flexibility for you and your family 💖\n- Helps you build confidence to pursue a meaningful career path 🌟\nWith some clarity and planning, coaching could be your next great step.",
      "link": ""
    },
    {
      "grade": "I",
      "title": "Taking the First Step Towards Fulfillment",
      "caption": "You're still unsure about the right direction, but you're ready for change! 🛤\nCoaching could be the path that allows you to balance family and work while feeling fulfilled. Now is the time to begin exploring how it could fit into your life.\n👉 What You’ll Gain:\n- A career with purpose and flexibility 💖\n- An opportunity to help others while creating balance in your own life ⚖️\n- The chance to make a real difference while aligning with your passions 🌸\nStart small, but start today — coaching can lead to a fulfilling future.",
      "link": ""
    }
  ]
  ,
  quiz5: [
    {
      "grade": "A",
      "title": "You're Just Getting Started!",
      "caption": "You're in the early stages of your coaching journey! 📚\nYou may be starting to explore coaching and aren't yet certified, but you're eager to learn and grow. With the right tools and training, you’ll be able to create a fulfilling career that aligns with your passions.\n👉 What You’ll Gain:\n- A structured path to certification 🎓\n- Tools to help you start your coaching practice 🚀\n- Confidence to guide others towards their goals 💡\nLet’s take the first step toward your coaching future!",
      "link": ""
    },
    {
      "grade": "B",
      "title": "You're Ready to Build Momentum!",
      "caption": "You’re on your way, and you’ve already built a solid foundation. 💪\nYou may have your certification and a steady client base, but there’s still room to grow. You're open to learning more and refining your skills to reach new heights.\n👉 What You’ll Gain:\n- Strategies to attract higher-level clients 💼\n- Advanced coaching tools to tackle complex issues 🔧\n- Insights into creating a more sustainable business 📈\nYou're almost there – let’s refine your practice for long-term success!",
      "link": ""
    },
    {
      "grade": "C",
      "title": "You're Gaining Confidence!",
      "caption": "You're getting more confident in your coaching abilities and in handling complex situations. 🌟\nYou’ve attracted high-level clients and are now focused on growing your impact even further. It’s time to hone your expertise and continue learning.\n👉 What You’ll Gain:\n- Techniques for refining your coaching practice 🛠️\n- Ways to expand your client base and visibility 📢\n- Insights on scaling your coaching business 🚀\nKeep pushing your boundaries – you’re on the right track!",
      "link": ""
    },
    {
      "grade": "D",
      "title": "You're an Advanced Coach!",
      "caption": "You’re confident and ready to take your coaching career to the next level. 🏆\nYou’ve worked with elite clients and now aim to solidify your position as a leader in the industry. Advanced training will help you elevate your practice to new heights.\n👉 What You’ll Gain:\n- Strategies to attract top-tier clients 🌟\n- Tools for elevating your influence in the coaching world 🌍\n- Ways to increase your visibility and thought leadership 💬\nYou’re a leader in your field – now it’s time to shape the future!",
      "link": ""
    },
    {
      "grade": "E",
      "title": "You’re Becoming a Seasoned Coach!",
      "caption": "You’ve built a successful coaching practice and feel confident in your abilities. 🌟\nYour focus is now on refining your niche and expanding your impact. You have the tools and knowledge to continue scaling your business and helping more clients.\n👉 What You’ll Gain:\n- Insights into mastering your niche 🧠\n- Ways to further grow and refine your practice 💼\n- Strategies for increasing your business influence 📢\nContinue your journey – you’re almost at the top!",
      "link": ""
    },
    {
      "grade": "F",
      "title": "You're a Master Coach!",
      "caption": "You’ve already established yourself as an expert coach, and you’re now focused on expanding your influence globally. 🌍\nYour practice is thriving, and you're ready to reach even greater heights. You aim to be recognized as a thought leader and scale your brand.\n👉 What You’ll Gain:\n- Strategies for global expansion 🌐\n- Techniques for refining your thought leadership 🔍\n- Ways to scale your business even further 📊\nYou're at the top – let's help you grow even more!",
      "link": ""
    },
    {
      "grade": "G",
      "title": "You're an Elite Coach!",
      "caption": "You’ve cemented your place as a leader in the coaching industry, and now you’re focused on elevating your influence. 💫\nYou’re attracting high-profile clients and are looking for new ways to refine your approach, expand your visibility, and increase your impact.\n👉 What You’ll Gain:\n- Tools for increasing your influence and visibility 🌟\n- Strategies to attract top-tier clients 🏆\n- Ways to scale your impact globally 🌍\nYou're a coaching industry leader – let’s help you shine even brighter!",
      "link": ""
    },
    {
      "grade": "H",
      "title": "You're a Visionary Coach!",
      "caption": "You’re no longer just a coach – you’re a visionary, shaping the future of coaching. 🌟\nYour focus is on building your global brand, mentoring the next generation of coaches, and making a long-lasting impact on the industry.\n👉 What You’ll Gain:\n- Strategies for global brand building 🌐\n- Techniques for becoming a thought leader 🧠\n- Ways to leave a legacy and shape the future of coaching 🔮\nYou’ve reached the pinnacle – let’s continue to make history together!",
      "link": ""
    },
    {
      "grade": "I",
      "title": "You’re a Coaching Legend!",
      "caption": "You’ve already achieved legendary status in the coaching world. 🌍\nNow, you’re focused on innovating and transforming the entire industry with your vision, influence, and expertise.\n👉 What You’ll Gain:\n- New methods for transforming the coaching industry 🔄\n- Strategies to mentor the next generation of coaches 🧑‍🏫\n- Ways to lead large-scale global movements 🌐\nYou're a coaching icon – let’s shape the future together!",
      "link": ""
    }
  ]
  ,
};

const handleSubmitToSheets = async (name, email, phone, quiz, grade) => {
  try {
    const params = new URLSearchParams();
    params.append("name", name);
    params.append("email", email);
    params.append("phone", phone);
    params.append("quiz", quiz);
    params.append("grade", grade);
    await fetch(
      "https://script.google.com/macros/s/AKfycbxTgvF2FoyaMB-x9MpkAQhzY8KDfVHzGgQ4cvVdE84XDsKro1TtkydFclTKGk7bxp63/exec",
      {
        method: "POST",
        body: params,
      }
    );
  } catch (error) {
    console.error(error);
  }
};

export const StartQuiz = () => {
  const { id } = useParams();

  const quizzes = {
    quiz1: [
      {
        question: "Do you feel stuck in your current job or career?",
        options: [
          { text: "Yes, I feel unfulfilled", value: "A" },
          { text: "Sometimes, but I'm making it work", value: "B" },
          { text: "No, I'm happy with my current path", value: "C" },
        ],
      },
      {
        question: "What is your biggest frustration at work right now?",
        options: [
          { text: "Lack of growth and recognition", value: "A" },
          { text: "I’m overwhelmed, but there’s no real change", value: "B" },
          {
            text: "I have no work-life balance and feel burnt out",
            value: "C",
          },
        ],
      },
      {
        question:
          "Do you often find yourself giving advice to friends, family, or colleagues to help them improve their lives or careers?",
        options: [
          { text: "Yes, all the time! I love helping others", value: "A" },
          {
            text: "Sometimes, but it feels like I’m just offering suggestions",
            value: "B",
          },
          { text: "Not really, I tend to keep to myself", value: "C" },
        ],
      },
      {
        question: "How important is flexibility in your career?",
        options: [
          {
            text: "Extremely! I want to be able to work from anywhere and set my own schedule",
            value: "A",
          },
          {
            text: "Somewhat important, but I can manage a fixed schedule",
            value: "B",
          },
          { text: "I’m okay with a traditional 9-5 structure", value: "C" },
        ],
      },
      {
        question:
          "Do you want to have a meaningful impact on other people’s lives?",
        options: [
          {
            text: "Absolutely, I want to inspire and help people reach their full potential",
            value: "A",
          },
          { text: "Yes, but I'm not sure how to do that", value: "B" },
          { text: "Not sure—maybe in the future", value: "C" },
        ],
      },
      {
        question:
          "Do you believe that your current skills or experience could be used to help others reach their personal or professional goals?",
        options: [
          {
            text: "Yes, I feel I have untapped potential to guide others",
            value: "A",
          },
          {
            text: "Maybe, but I don’t know how to leverage my skills for coaching",
            value: "B",
          },
          { text: "I’m not sure. I haven’t thought about it much", value: "C" },
        ],
      },
    ],
    quiz2: [
      {
        question: "How much time do you have each day for work?",
        options: [
          {
            text: "I have a few hours in the morning or evening when the kids are at school or after they sleep",
            value: "A",
          },
          {
            text: "I can spare a couple of hours here and there, but I don’t want to commit to something full-time",
            value: "B",
          },
          {
            text: "I have a full day to dedicate, but only if it’s something flexible.",
            value: "C",
          },
          {
            text: "I have a lot of time, but I want a stress-free job without too many deadlines",
            value: "D",
          },
        ],
      },
      {
        question: "What’s your biggest priority right now?",
        options: [
          {
            text: "I want a job that doesn’t take too much time but still lets me earn an income.",
            value: "A",
          },
          {
            text: "I want to find a flexible career that allows me to spend more time with family or do other things I enjoy.",
            value: "B",
          },
          {
            text: "I’m looking for a career where I can gradually build my income and have a sense of accomplishment.",
            value: "C",
          },
          {
            text: "I want a job that’s meaningful, but I don’t want the added stress and pressure.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How comfortable are you with working from home or at your own pace?",
        options: [
          {
            text: "I’d love the idea of working from home, where I can work when it fits into my day.",
            value: "A",
          },
          {
            text: "I’m okay with working from home but don’t want too much pressure.",
            value: "B",
          },
          {
            text: "I’d prefer some flexibility, but I don’t mind setting a schedule.",
            value: "C",
          },
          {
            text: "I’d prefer a structured job, but without high expectations or stress",
            value: "D",
          },
        ],
      },
      {
        question:
          "How do you feel about the idea of helping others, even in small ways?",
        options: [
          {
            text: "I love the idea of helping people, but I don’t want to be responsible for big changes or commitments",
            value: "A",
          },
          {
            text: "I want to make a difference, but without feeling overwhelmed or stretched too thin.",
            value: "B",
          },
          {
            text: "I’m open to helping others, but I need a clear structure and guidance.",
            value: "C",
          },
          {
            text: "I enjoy helping people but only if it’s low-effort and doesn’t take a lot of energy",
            value: "D",
          },
        ],
      },
      {
        question: "What’s your ideal work-life balance?",
        options: [
          {
            text: "I want to work only when it fits my schedule—morning, evening, or weekends",
            value: "A",
          },
          {
            text: "I want to work at my own pace without a heavy workload or strict deadlines",
            value: "B",
          },
          {
            text: "I’d like to contribute meaningfully to others, but not at the cost of my personal life",
            value: "C",
          },
          {
            text: "I want a career that allows me to spend time with family and do what I love—without stress!",
            value: "D",
          },
        ],
      },
      {
        question:
          "How important is it for you to have a job that doesn’t require a lot of ongoing commitment?",
        options: [
          {
            text: "Extremely important! I need something that allows me to be flexible and not overly committed.",
            value: "A",
          },
          {
            text: "I want a job that gives me freedom but is still rewarding.",
            value: "B",
          },
          {
            text: "I’m okay with some commitment as long as it’s manageable and flexible",
            value: "C",
          },
          {
            text: "I don’t want to feel bound by a job or be responsible for too much",
            value: "D",
          },
        ],
      },
    ],
    quiz3: [
      {
        question: "What best describes your current situation?",
        options: [
          {
            text: "I’m staying at home and want a career that offers flexibility and the ability to balance family life with earning an income",
            value: "A",
          },
          {
            text: "I’m juggling family responsibilities and a demanding job, and I’m craving a career that offers more freedom and flexibility.",
            value: "B",
          },
          {
            text: " I want a career that helps others while still allowing me to take care of my family and personal well-being.",
            value: "C",
          },
          {
            text: "I feel unfulfilled in my current career, and I’m ready to make a significant change that aligns with my passions and purpose.",
            value: "D",
          },
        ],
      },
      {
        question:
          " How do you currently feel about your ability to balance work and personal life?",
        options: [
          {
            text: "It feels impossible. I’m constantly overwhelmed and struggle to find time for anything beyond the basics.",
            value: "A",
          },
          {
            text: "It’s a daily struggle. I manage to keep things together, but there’s never enough time for everything, and I often feel drained.",
            value: "B",
          },
          {
            text: " I’m balancing well, but I need a career that respects my personal time and doesn’t overwhelm me.",
            value: "C",
          },
          {
            text: "I’m managing okay, but I know I could be doing better with more control over my schedule and the opportunity to focus on what matters most.",
            value: "D",
          },
        ],
      },
      {
        question:
          "Do you enjoy helping others solve their problems or make life decisions?",
        options: [
          {
            text: "Yes! I love offering advice to friends and family, but I don’t know how to turn it into a career.",
            value: "A",
          },
          {
            text: "I enjoy it, but I feel uncertain about my ability to make a real difference. I don’t have the professional skills to help on a deeper level.",
            value: "B",
          },
          {
            text: "Absolutely! I’ve always been the go-to person for advice, and I’d love to help others in a more structured, impactful way",
            value: "C",
          },
          {
            text: "Yes, I’ve always wanted a career where I can guide and support others. I feel ready to dive in and make this a full-time career.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How comfortable are you with learning new skills and growing in your career?",
        options: [
          {
            text: " I’m open to learning, but I need something that won’t be overwhelming and fits with my current responsibilities.",
            value: "A",
          },
          {
            text: " I’d love to learn new skills, but I’m unsure how to balance it with my family life. I need something flexible.",
            value: "B",
          },
          {
            text: "I’m eager to grow, but I need to find a career that lets me do that at my own pace and in a way that fits around my family life.",
            value: "C",
          },
          {
            text: "I’m excited to learn and take on new challenges. I’m ready for a fresh career and to develop myself in a meaningful way.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How do you feel about the idea of becoming a certified coach?",
        options: [
          {
            text: "I’ve never really thought about coaching, but it sounds like it could be a good fit. I want a career that’s flexible and meaningful.",
            value: "A",
          },
          {
            text: "I think coaching could work for me, but I’m not sure if I can balance it with my family life or other commitments.",
            value: "B",
          },
          {
            text: "Coaching seems like a great way to use my skills and passions to help others, but I want to ensure it’s something I can do on my own terms.",
            value: "C",
          },
          {
            text: "I’ve been considering coaching for a while, and I’m ready to take the leap. I want to make a big impact and create a meaningful career.",
            value: "D",
          },
        ],
      },
      {
        question:
          "What’s currently stopping you from pursuing a new career path?",
        options: [
          {
            text: "Time is my biggest obstacle. Between family and household responsibilities, it feels impossible to make time for anything else.",
            value: "A",
          },
          {
            text: "I lack confidence. I don’t feel qualified to pursue something new and worry about failing or not measuring up.",
            value: "B",
          },
          {
            text: "I’m unsure how to transition into a new career that works with my life. I want something meaningful, but I need it to fit into my current routine.",
            value: "C",
          },
          {
            text: "I’ve hesitated in the past, but now I’m ready. I know it’s time for a change, and I want to pursue something that lights me up.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How important is it for you to have a career that aligns with your values and allows you to help others?",
        options: [
          {
            text: "It’s essential. I want a job that gives me the flexibility to support my family and make a difference in the world.",
            value: "A",
          },
          {
            text: "I want to make an impact, but I also need flexibility. I need a career that supports both my family life and my personal values.",
            value: "B",
          },
          {
            text: "Making a difference is a priority for me. I just need a career that works on my terms and doesn’t overwhelm me.",
            value: "C",
          },
          {
            text: "I’ve always wanted to create a career that truly helps others. I’m ready to take on a role where I can make a real impact and live my values.",
            value: "D",
          },
        ],
      },
    ],
    quiz4: [
      {
        question:
          "What is your biggest struggle when it comes to balancing work and family life?",
        options: [
          {
            text: "Time. I never feel like I have enough hours in the day to get everything done.",
            value: "A",
          },
          {
            text: "Energy. I’m constantly exhausted from juggling work, family, and everything in between.",
            value: "B",
          },
          {
            text: "Flexibility. I need a career that allows me to work around my family’s needs and still bring in an income.",
            value: "C",
          },
          {
            text: "Fulfillment. I feel like I’m stuck in a career that doesn’t excite me or align with my values, but I need to support my family.",
            value: "D",
          },
        ],
      },
      {
        question: "How do you feel about your current career or job situation?",
        options: [
          {
            text: "It’s just a job. It pays the bills, but it’s not fulfilling, and I don’t feel like I’m making an impact.",
            value: "A",
          },
          {
            text: "I’m overwhelmed and burned out. I’m constantly switching between roles—employee, parent, spouse—and it’s hard to keep up.",
            value: "B",
          },
          {
            text: "I want something that offers *more flexibility* so I can prioritize my family while earning an income, but I’m not sure what.",
            value: "C",
          },
          {
            text: "I’m ready for a *career shift*. I feel like I’m not doing what I’m truly passionate about, and I’m craving something more meaningful.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How do you feel about helping others solve their problems or navigate difficult life challenges?",
        options: [
          {
            text: "I love offering advice to friends and family, but I don’t know how to make it a career",
            value: "A",
          },
          {
            text: "I’m great at listening and providing support, but I don’t feel like I have the professional tools or skills to help others effectively.",
            value: "B",
          },
          {
            text: "I have a natural talent for coaching others in my life, and I’d love to do it professionally, but I need something that allows me to work from home.",
            value: "C",
          },
          {
            text: "I’m passionate about making a real difference in others’ lives and have been thinking about how I can turn this into a meaningful career.",
            value: "D",
          },
        ],
      },
      {
        question:
          "What would make you feel more in control of your career and family life?",
        options: [
          {
            text: "The ability to *work from home* and manage my own hours, so I can be there for my family without sacrificing my career goals.",
            value: "A",
          },
          {
            text: "Having *more energy and boundaries* to prevent burnout and feel like I can focus on my family without neglecting my work responsibilities.",
            value: "B",
          },
          {
            text: "A career that offers *complete flexibility*, where I can control when and how much I work, while still having enough time for my family.",
            value: "C",
          },
          {
            text: "The opportunity to *pursue my passions* and create a career that makes me feel alive, all while maintaining balance in my life.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How open are you to learning new skills that could help you build a new career?",
        options: [
          {
            text: "I’m open to learning, but I need something that doesn’t take too much time away from my family or work.",
            value: "A",
          },
          {
            text: "I’d love to learn new skills, but I’m worried about the time commitment, especially with all my other responsibilities.",
            value: "B",
          },
          {
            text: "I’m excited about learning new things! I need a career that offers growth but is also flexible enough to fit into my busy schedule.",
            value: "C",
          },
          {
            text: "I’m ready to dive in and make a big change. I’m eager to develop my skills and shift into a new, more fulfilling career.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How would you feel about becoming a certified coach and helping others while having more flexibility in your life?",
        options: [
          {
            text: "I’ve never really thought about it, but I love the idea of using my experience as a parent to help others.",
            value: "A",
          },
          {
            text: "I’m interested but nervous about whether I could balance coaching with everything else in my life. It feels like a big commitment.",
            value: "B",
          },
          {
            text: "Coaching sounds like the perfect way to use my skills, but I need it to be flexible and fit around my family’s needs. I’d love to learn how to do this professionally.",
            value: "C",
          },
          {
            text: "I’ve thought about coaching before and feel like it could be the perfect path for me. I’m ready to pursue this career and make a real impact.",
            value: "D",
          },
        ],
      },
      {
        question:
          "What’s the main reason you’ve hesitated to pursue a new career or start a business?",
        options: [
          {
            text: "Time is a huge issue. Between work and family responsibilities, I can’t imagine finding the time to start something new.",
            value: "A",
          },
          {
            text: "Energy and confidence. I don’t feel like I have the energy or the knowledge to make a significant career shift.",
            value: "B",
          },
          {
            text: "I’m unsure about how to transition into something that would allow me to make money and still maintain my family’s needs and responsibilities.",
            value: "C",
          },
          {
            text: "I’ve been holding back because I’m not sure where to start or how to make a big career change. But I know it’s time to take the leap.",
            value: "D",
          },
        ],
      },
      {
        question:
          "When it comes to your career, what is the biggest barrier preventing you from making a change?",
        options: [
          {
            text: "The fear of not having enough time to balance a new career and family life.",
            value: "A",
          },
          {
            text: "Doubts about whether I have the necessary skills to succeed in a new career.",
            value: "B",
          },
          {
            text: "I feel overwhelmed by the thought of starting something completely new and unfamiliar.",
            value: "C",
          },
          {
            text: "I'm afraid of not being able to make enough money to support my family.",
            value: "D",
          },
        ],
      },
      {
        question:
          "If you could create the perfect work-life situation, what would it look like?",
        options: [
          {
            text: "A flexible career that allows me to work from home and be present for my family.",
            value: "A",
          },
          {
            text: "A job that gives me more control over my hours, so I can take care of my family and focus on personal growth.",
            value: "B",
          },
          {
            text: "A fulfilling career where I help others, with enough time for self-care and family activities.",
            value: "C",
          },
          {
            text: "A career where I am financially secure, yet still have time for my passions and family life.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How would you describe your ideal work environment as a coach?",
        options: [
          {
            text: "Working from home or remotely, with clients who understand and respect my time.",
            value: "A",
          },
          {
            text: "In-person coaching, but with a flexible schedule and a balance between my professional and personal life.",
            value: "B",
          },
          {
            text: "Working online or with a mix of remote and in-person, where I can help clients from diverse backgrounds and still be at home with my kids.",
            value: "C",
          },
          {
            text: "A hybrid model, where I can coach people from different walks of life, and have time to travel and take family vacations.",
            value: "D",
          },
        ],
      },
      {
        question:
          "If you could work with any type of client as a coach, who would it be?",
        options: [
          {
            text: "Parents like me who want to balance family life and work.",
            value: "A",
          },
          {
            text: "Individuals in career transitions, who need guidance in navigating their professional life.",
            value: "B",
          },
          {
            text: "Busy professionals who want to improve their work-life balance and find more fulfillment.",
            value: "C",
          },
          {
            text: "People who are struggling with self-doubt and lack of confidence, and need help finding their purpose.",
            value: "D",
          },
        ],
      },
    ],
    quiz5: [
      {
        question: "What best describes your current coaching certification?",
        options: [
          {
            text: "I am an ACC (Associate Certified Coach).",
            value: "A",
          },
          {
            text: "I am a PCC (Professional Certified Coach).",
            value: "B",
          },
          {
            text: "I am an MCC (Master Certified Coach).",
            value: "C",
          },
          {
            text: "I’m just starting out, and I’m not certified yet.",
            value: "D",
          },
        ],
      },
      {
        question:
          "What is the biggest challenge you’re facing as a coach right now?",
        options: [
          {
            text: "Struggling to gain clients and build a sustainable business.",
            value: "A",
          },
          {
            text: "I’ve hit a plateau and need more advanced tools to help my clients break through.",
            value: "B",
          },
          {
            text: "I want to refine my skills and learn new methods for handling complex situations.",
            value: "C",
          },
          {
            text: "I’m confident in my abilities, but I want to increase my impact and become a thought leader.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How confident do you feel in handling complex coaching scenarios (e.g., deep emotional or behavioral issues)?",
        options: [
          {
            text: "I feel uncertain and could use more strategies to manage difficult situations.",
            value: "A",
          },
          {
            text: "I can manage these situations, but I’m looking for more advanced tools to improve my results.",
            value: "B",
          },
          {
            text: "I’m very confident in handling complex issues, but I’m always open to refining my methods",
            value: "C",
          },
          {
            text: "I’m extremely confident in my approach but always look for ways to continue growing and learning.",
            value: "D",
          },
        ],
      },
      {
        question: "How would you describe your client base right now?",
        options: [
          {
            text: "I’m still working on building a solid client base and need help with marketing and attracting high-value clients.",
            value: "A",
          },
          {
            text: "I have a steady client base, but I’d like to work with higher-level clients or expand my niche.",
            value: "B",
          },
          {
            text: "I’m already attracting high-level clients, but I’m looking for ways to further grow my impact.",
            value: "C",
          },
          {
            text: "I’m already working with elite clients and want to solidify my position as an industry leader.",
            value: "D",
          },
        ],
      },
      {
        question:
          "What’s your biggest roadblock in growing your coaching business?",
        options: [
          {
            text: "I don’t know how to market myself effectively or build a strong online presence.",
            value: "A",
          },
          {
            text: "I’m struggling with creating a consistent flow of new clients, despite my existing skills",
            value: "B",
          },
          {
            text: "I feel stuck in my current niche or need a more refined strategy to grow and scale.",
            value: "C",
          },
          {
            text: "I have a successful practice but need strategies to elevate my influence and visibility even more.",
            value: "D",
          },
        ],
      },
      {
        question:
          "How comfortable are you with the idea of expanding your knowledge and skills as a coach?",
        options: [
          {
            text: "I’m eager to learn and develop my skills further.",
            value: "A",
          },
          {
            text: "I’m open to advanced training and tools that will help me deepen my practice.",
            value: "B",
          },
          {
            text: "I feel confident in my abilities, but I’m always open to new methods and growth",
            value: "C",
          },
          {
            text: "I’m passionate about continuous learning and looking for the next breakthrough to expand my impact.",
            value: "D",
          },
        ],
      },
      {
        question:
          "Where would you like to take your coaching career in the next 12 months?",
        options: [
          {
            text: "I want to get certified and build a successful coaching business.",
            value: "A",
          },
          {
            text: "I’d like to specialize in a niche and elevate my status as an expert",
            value: "B",
          },
          {
            text: "I want to scale my business, work with high-profile clients, and refine my approach.",
            value: "C",
          },
          {
            text: "I’m looking to establish myself as a thought leader and expand my coaching brand globally.",
            value: "D",
          },
        ],
      },
    ],
  };

  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [responses, setResponses] = useState([]);
  const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
  const [isQuizComplete, setIsQuizComplete] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentQuestionIndex, isQuizComplete]);

  const quiz = quizzes[id];

  const getGradeDetails = (grade, id) => {
    const quizResults = results[id];

    if (!quizResults) {
      return { title: "Unknown Quiz", caption: "Quiz not found", link: "#" };
    }

    const details = quizResults.find((item) => item.grade === grade);
    return (
      details || {
        title: "Unknown Grade",
        caption: "Grade not found",
        link: "#",
      }
    );
  };

  if (!quiz) {
    return <div>Quiz not found</div>;
  }

  const currentQuestion = quiz[currentQuestionIndex];
  const totalQuestions = quiz.length;

  const handleOptionChange = (value) => {
    setSelectedOption(value);
  };

  const handleSubmit = () => {
    if (!selectedOption) {
      alert("Please select an option");
      return;
    }

    const newResponses = [...responses, selectedOption];
    setResponses(newResponses);

    if (selectedOption === currentQuestion.correctAnswer) {
      setCorrectAnswersCount(correctAnswersCount + 1);
    }

    setSelectedOption("");

    if (currentQuestionIndex < totalQuestions - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
    } else {
      setIsQuizComplete(true);
    }
  };

  const grade = () => {
    const counts = { A: 0, B: 0, C: 0, D: 0 };

    responses.forEach((response) => {
      counts[response]++;
    });

    let totalScore = 0;

    const points = { A: 4, B: 3, C: 2, D: 1 };

    responses.forEach((response) => {
      totalScore += points[response] || 0;
    });

    const avgScore = totalScore / responses.length;

    console.log(avgScore);

    if (avgScore <= 1.3) return "I";
    if (avgScore <= 1.6) return "H";
    if (avgScore <= 1.9) return "G";
    if (avgScore <= 2.2) return "F";
    if (avgScore <= 2.5) return "E";
    if (avgScore <= 2.8) return "D";
    if (avgScore <= 3.1) return "C";
    if (avgScore <= 3.4) return "B";
    if (avgScore <= 3.7) return "B";
    return "A";
  };

  if (isQuizComplete) {
    const userGrade = grade();
    const { title, caption } = getGradeDetails(userGrade, id);
    const userData = localStorage.getItem("userData");

    if (userData) {
      const userObject = JSON.parse(userData);

      console.log(userObject.name);
      console.log(userObject.email);
      console.log(userObject.phone);
      console.log(id);
      console.log(userGrade);

      handleSubmitToSheets(
        userObject.name,
        userObject.email,
        userObject.phone,
        id,
        userGrade
      );
    }

    return (
      <div
        style={{
          padding: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap-reverse",
          gap: "30px",
          minHeight: "500px",
        }}
      >
        <div
          style={{
            maxWidth: "500px",
            display: "flex",
            flexDirection: "column",
            gap: "30px",
          }}
        >
          <p
            style={{
              fontSize: "40px",
              textAlign: "left",
              lineHeight: "1.2",
            }}
          >
            {title}
          </p>
          <p
  style={{
    fontSize: "16px",
    lineHeight: "1.2",
    whiteSpace: "pre-wrap",
  }}
>
  {caption.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).map((part, index) => {
    if (/^\*\*[^*]+\*\*$/.test(part)) {
      return (
        <span key={index} style={{ fontWeight: "bolder" }}>
          {part.slice(2, -2)}
        </span>
      );
    } else if (/^\*[^*]+\*$/.test(part)) {
      return (
        <span key={index} style={{ fontWeight: "bold" }}>
          {part.slice(1, -1)}
        </span>
      );
    } else {
      return <span key={index}>{part}</span>;
    }
  })}
</p>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              backgroundColor: "#f9f9f9",
              padding: "20px",
              borderLeft: "6px solid #128788", // Blue accent for blockquote
              borderRadius: "8px",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              fontFamily: "Arial, sans-serif",
              maxWidth: "500px",
            }}
          >
            <p
              style={{
                fontSize: "20px",
                textAlign: "left",
                lineHeight: "1.3",
                fontWeight: "bold",
                color: "#333",
                margin: "0",
              }}
            >
              “Want to Learn More About Your Coaching Journey?”
            </p>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.4",
                color: "#555",
                whiteSpace: "pre-wrap",
                margin: "0",
              }}
            >
              Schedule a call with us to understand how this certification is
              relevant for you, or start with ICF Level 1 to kickstart your
              coaching career.
            </p>
            <div
              style={{
                display: "flex",
                gap: "10px",
                marginTop: "12px",
                flexWrap: "wrap",
              }}
            >
              <PrimaryButton
                label={"Schedule a Call"}
                onClick={() => {
                  const phoneNumber = "9819926379";
                  const message = encodeURIComponent(
                    "Hi, I’m interested in learning more about ICF certification. Can we schedule a call?"
                  );
                  window.open(
                    `https://wa.me/${phoneNumber}?text=${message}`,
                    "_blank"
                  );
                }}
              />

              <SecondaryButton
                label={"Get Started with ICF"}
                onClick={() => {
                  window.location.replace("/resource/icf-level-1");
                }}
              />
            </div>
          </div>
        </div>
        <div style={{ maxWidth: "300px" }}>
          <img
            src="https://static.vecteezy.com/system/resources/previews/032/999/982/non_2x/realistic-golden-trophy-ai-generative-free-png.png"
            alt="trophy"
            style={{ width: "100%", objectFit: "cover" }}
          />
        </div>
      </div>
    );
  }

  const progressPercentage = Math.round(
    (currentQuestionIndex / totalQuestions) * 100
  );

  const radius = 50;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progressPercentage / 100) * circumference;

  return (
    <div
      style={{
        padding: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap-reverse",
        gap: "30px",
        minHeight: "500px",
      }}
    >
      <div
        style={{
          maxWidth: "500px",
          display: "flex",
          flexDirection: "column",
          gap: "30px",
        }}
      >
        <p
          style={{
            fontSize: "40px",
            textAlign: "left",
            lineHeight: "1.2",
          }}
        >
          {currentQuestion.question}
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {currentQuestion.options.map((option, index) => (
            <div key={index}>
              <div
                style={{
                  display: "flex",
                  border:
                    selectedOption === option.value
                      ? "2px solid #107988"
                      : "2px solid black",
                  borderRadius: "8px",
                  padding: "1px",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
                onClick={() => handleOptionChange(option.value)}
              >
                <p
                  style={{
                    backgroundColor: "#D9D9D9",
                    padding: "10px",
                    borderTopLeftRadius: "6px",
                    borderBottomLeftRadius: "6px",
                    fontSize: "18px",
                    fontWeight: "bold",
                  }}
                >
                  {option.value}
                </p>
                <p
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    fontSize: "16px",
    lineHeight: "1.2",
    // textAlign: "center",
    flexDirection: "column",
    whiteSpace: "pre-wrap", // Optional for preserving line breaks too
  }}
>
  {option.text.split(/\n/).map((line, lineIndex) => (
    <span key={lineIndex}>
      {line.split(/(\*[^*]+\*)/g).map((part, index) =>
        part.startsWith("*") && part.endsWith("*") ? (
          <strong key={index}>{part.slice(1, -1)}</strong>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </span>
  ))}
</p>

                {selectedOption === option.value && (
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      alignItems: "center",
                      justifyContent: "flex-end",
                      paddingRight: "10px",
                    }}
                  >
                    <img src={CheckIcon} alt="tick" height={20} width={20} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div>
          <PrimaryButton
            onClick={handleSubmit}
            label={
              currentQuestionIndex < quiz.length - 1
                ? "Submit Answer"
                : "Finish"
            }
          />
        </div>
      </div>

      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "30px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          <svg width="120" height="120" viewBox="0 0 120 120">
            <circle
              cx="60"
              cy="60"
              r={radius}
              fill="transparent"
              stroke="#ddd"
              strokeWidth="20"
            />
            <circle
              cx="60"
              cy="60"
              r={radius}
              fill="transparent"
              stroke="#107988"
              strokeWidth="20"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              style={{
                transition: "stroke-dashoffset 0.35s",
                strokeLinecap: "round",
              }}
            />
          </svg>
          <p
            style={{ position: "absolute", fontSize: "24px", color: "#107988" }}
          >
            {progressPercentage}%
          </p>
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            maxWidth: "300px",
            flexWrap: "wrap",
          }}
        >
          {Array.from({ length: totalQuestions }).map((_, index) => (
            <div
              key={index}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "5px",
                backgroundColor:
                  index <= currentQuestionIndex - 1 ? "#107988" : "#ddd",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "white",
              }}
            >
              <p
                style={{
                  fontSize: "16px",
                  textAlign: "center", // Align text centrally
                  lineHeight: "1.2",
                }}
              >
                {index + 1}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};